<template>
  <div v-if="userdata">
    <b-card>
      <b-card-body class="p-0">
        <!-- User Info: Input Fields -->
        <b-form class="mt-1">
          <b-row>
            <!-- Field: Full Name -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('contributors.full-name')"
                label-for="full-name"
              >
                <b-form-input
                  id="full-name"
                  v-model="userdata.fullName"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Status -->
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('contributors.contributor-type')"
                label-for="contributor-type"
              >
                <v-select
                  v-model="userdata.infos.contributorType"
                  :options="lookupOptions.contributorTypeOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="contributor-type"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('contributors.filter-status-label')"
                label-for="user-status"
              >
                <v-select
                  v-model="userdata.infos.status"
                  :options="lookupOptions.statusOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="user-status"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="2"
            >
              <b-form-group
                :label="$t('contributors.code')"
                label-for="code"
              >
                <b-form-input
                  id="code"
                  v-model="userdata.infos.contributorCode"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Birth Date -->
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('contributors.birth-date')"
                label-for="birth-date"
              >
                <date-picker-input
                  id="birth-date"
                  v-model="userdata.infos.birthDate"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Fiscal Code -->
            <b-col
              cols="12"
              md="6"
              lg="4"
            >
              <b-form-group
                :label="$t('contributors.fiscal-code')"
                label-for="fiscal-code"
              >
                <b-form-input
                  v-model="userdata.infos.fiscalCode"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Gender -->
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('contributors.gender')"
                label-for="gender"
                label-class="mb-1"
              >
                <b-form-radio-group
                  id="gender"
                  v-model="userdata.infos.gender"
                  :options="genderOptions"
                />
              </b-form-group>
            </b-col>
            <!-- Field: eMail -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('contributors.email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="userdata.infos.email"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Contact -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('contributors.contact')"
                label-for="contact"
              >
                <b-form-input
                  id="contact"
                  v-model="userdata.infos.contact"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Anno adesione -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('contributors.annoAdesione')"
                label-for="annoAdesione"
              >
                <b-form-input
                  id="annoAdesione"
                  v-model="userdata.infos.annoAdesione"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Anno cancellazione -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('contributors.annoCancellazione')"
                label-for="annoCancellazione"
              >
                <b-form-input
                  id="annoCancellazione"
                  v-model="userdata.infos.annoCancellazione"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Sorgente -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('contributors.sorgente')"
                label-for="sorgente"
              >
                <b-form-input
                  id="sorgente"
                  v-model="userdata.infos.sorgente"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Header: Personal Info -->
          <div class="d-flex mt-2">
            <feather-icon
              icon="MapPinIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              {{ $t('contributors.address') }}
            </h4>
          </div>

          <!-- Form: Personal Info Form -->
          <b-row class="mt-1">

            <!-- Field: Address Line 1 -->
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <b-form-group
                :label="$t('contributors.address-line')"
                label-for="address-line-1"
              >
                <b-form-input
                  id="address-line-1"
                  v-model="userdata.infos.address.addressLine"
                />
              </b-form-group>
            </b-col>
            <!-- Field: City -->
            <b-col
              cols="12"
              md="6"
              lg="6"
            >
              <b-form-group
                :label="$t('contributors.address-city')"
                label-for="city"
              >
                <b-form-input
                  id="city"
                  v-model="userdata.infos.address.city"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Postcode -->
            <b-col
              cols="12"
              md="2"
              lg="2"
            >
              <b-form-group
                :label="$t('contributors.address-postcode')"
                label-for="postcode"
              >
                <b-form-input
                  id="postcode"
                  v-model="userdata.infos.address.postcode"
                  type="number"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Kanton  -->
            <b-col
              v-if="userdata.infos.address.state === 'CH'"
              cols="12"
              md="2"
              lg="2"
            >
              <b-form-group
                :label="$t('contributors.address-kanton')"
                label-for="kanton"
              >
                <v-select
                  v-model="userdata.infos.address.kanton"
                  :options="kantonOptions"
                  :reduce="val => val.value"
                  input-id="kanton"
                />
              </b-form-group>
            </b-col>

            <!-- Field: PV  -->
            <b-col
              v-if="userdata.infos.address.state !== 'CH'"
              cols="12"
              md="2"
              lg="2"
            >
              <b-form-group
                :label="$t('contributors.address-kanton')"
                label-for="kanton-pv"
              >
                <v-select
                  v-model="userdata.infos.address.kanton"
                  :options="provinceOptions"
                  :reduce="val => val.value"
                  input-id="kanton-pv"
                />
              </b-form-group>
            </b-col>

            <!-- Field: State -->
            <b-col
              cols="12"
              md="2"
              lg="2"
            >
              <b-form-group
                :label="$t('contributors.address-state')"
                label-for="state"
                label-class="mb-1"
              >
                <b-form-radio-group
                  id="state"
                  v-model="userdata.infos.address.state"
                  :options="stateOptions"
                />
              </b-form-group>
            </b-col>

          </b-row>

          <b-row v-if="userdata.cid">
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <hr>
              <attachments-edit
                v-model="userdata.attachments"
                :refaid="refaid"
                class="mt-2"
              />
            </b-col>
          </b-row>
        </b-form></b-card-body></b-card>
  </div>
</template>

<script>

import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BFormRadioGroup, BCardBody, BCard,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import lookupsService from '@/vue.lookups.service'
import AttachmentsEdit from '../attachments/AttachmentsEdit.vue'
import DatePickerInput from '../layouts/DatePickerInput.vue'

export default {
  components: {
    BRow, BCol, BFormGroup, BFormInput, BForm, BCardBody, BCard, BFormRadioGroup, vSelect, AttachmentsEdit, DatePickerInput,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    lookupOptions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    userdata: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
  },
  setup() {
    const genderOptions = lookupsService.getGenderOptions()
    const stateOptions = lookupsService.getStateOptions()
    const kantonOptions = lookupsService.getKantonOptions()
    const provinceOptions = lookupsService.getProvinceOptions()
    return {
      stateOptions,
      genderOptions,
      kantonOptions,
      provinceOptions,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
